module.exports = __webpack_public_path__ + "img/thuisbezorgd-logo.0084d5bd.png";